import React from "react";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";

function CategoryBarForMobile() {
  const data = [
    {
      image: "headerLogos/8.jpg",
      title: "Lawyers Clothing",
      page: "/products?maincat=Cloths-Accessories",
    },
    {
      image: "headerLogos/3.jpg",
      title: "Research Software",
      page: "/software",
    },
    {
      image: "headerLogos/6.jpg",
      title: "Paralegal Partner",
      page: "/leagleReaserch",
    },
    {
      image: "headerLogos/4.jpg",
      title: "Litigation Mgmt",
      page: "/lms",
    },
    {
      image: "headerLogos/5.jpg",
      title: "Dictation & Trans.",
      page: "/dandt",
    },
    {
      image: "headerLogos/1.jpg",
      title: "Law Book Store",
      page: "/products?maincat=Books",
    },
    {
      image:
        "https://png.pngtree.com/recommend-works/png-clipart/20241011/ourmid/pngtree-3d-gavel-with-right-sign-law-and-justice-concept-png-image_14075430.png",
      title: "Recommended",
      page: "/RecommendedLink",
    },
  ];

  return (
    <Box
      display={{ base: "block", md: "none" }}
      bg="#FFFFFF"
      borderBottom="1px solid #E2E8F0"
      py="3"
      px="2"
      overflowX="auto"
      css={{
        "&::-webkit-scrollbar": { display: "none" },
        scrollbarWidth: "none",
      }}
    >
      <Flex gap="3" px="2" minW="max-content">
        {data.map((item, index) => (
          <NavLink key={index} to={item.page}>
            <Flex
              direction="column"
              align="center"
              w="76px"
              textAlign="center"
              cursor="pointer"
              _active={{ transform: "scale(0.96)" }}
            >
              <Box
                w="46px"
                h="46px"
                p="1.5"
                rounded="xl"
                bg="#F8FAFC"
                border="1px solid #E2E8F0"
                shadow="0 1px 3px rgba(0,0,0,0.05)"
                display="flex"
                alignItems="center"
                justifyContent="center"
                mb="1.5"
              >
                <Image
                  src={item.image}
                  alt={item.title}
                  maxH="100%"
                  maxW="100%"
                  objectFit="contain"
                />
              </Box>
              <Text
                fontSize="10.5px"
                fontWeight="600"
                color="gray.700"
                lineHeight="1.2"
                noOfLines={2}
              >
                {item.title}
              </Text>
            </Flex>
          </NavLink>
        ))}
      </Flex>
    </Box>
  );
}

export default CategoryBarForMobile;